import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
import { environment } from '../../../environments/environment';
import { timeout, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private headers = new HttpHeaders({
    'Content-Type':'application/json; charset=utf-8',
    'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0'
  });

  private headersInt = new HttpHeaders({
    'Content-Type':'application/json; charset=utf-8',
    'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0',
  });

  constructor(public http: HttpClient, public sessionStorage:SessionStorageService)  { }
  
    str_apiLink = `${environment.ApiHost.host.match(/(tantrasoft|62.171.187.143)/gi) != null ? 'https' : 'http'}://${environment.ApiHost.host}:${environment.ApiHost.APIPORT}/API/`;

  // headers removed from here and added in interceptor.

  // ******************************************************************************************* //
  // getMethod() - function takes argument as link and passed to to a Node server                //
  // ******************************************************************************************* //
  getMethod(link:string)
  {
    return this.http.get(this.str_apiLink + link)
  }
  // ******************************************************************************************* //
  // postMethod() - function takes argument as link and data, passes request to a Node  server  //
  // ****************************************************************************************** //
  postMethod(link: string, data: any) {
  // If data is FormData, don't set headers
  if (data instanceof FormData) {
    return this.http.post(this.str_apiLink + link, data);
  }
  return this.http.post(this.str_apiLink + link, data, { headers: this.headers });
}
  // ****************************************************************************************** //
  // putMethod() - function takes argument as link and data, passes request to a Node  server  //
  // ******************************************************************************************* //
  putMethod(link: string, data: any)
  {
    
    return this.http.put(this.str_apiLink + link, data)
  }
  
  // ******************************************************************************************* //
  // postMethod() - function takes argument as link and data, passes request to a Node  server  //
  // ****************************************************************************************** //
  postMethodForIndex(link: string, data: any)
  {
    let str_apiLink = this.str_apiLink.replace('API/','')
    return this.http.post(str_apiLink + link, data)
  }

  /***********************************************************************************************/

      // ******************************************************************************************* //
  // getMethod() - function takes argument as link and passed to to a Node server                //
  // ******************************************************************************************* //
  getMethodTSH(link:any)
  {
    return this.http.get(`http://${this.sessionStorage.retrieve('info').hostapi}:${this.sessionStorage.retrieve('info').portapi}/GRAN_INTER/` + link, { headers: this.headers }).pipe(
      timeout({
        each: 150000,
        with: () => throwError(() => new Error('Something Went Wrong'))
      })
    )
  }
  // ******************************************************************************************* //
  // postMethod() - function takes argument as link and data, passes request to a Node  server  //
  // ****************************************************************************************** //
  postMethodTSH(link:any, data?:any)
  {
    return this.http.post(`http://${this.sessionStorage.retrieve('info').hostapi}:${this.sessionStorage.retrieve('info').portapi}/GRAN_INTER/` + link, data,{ headers: this.headers }).pipe(
      timeout({
        each: 150000,
        with: () => throwError(() => new Error('Something Went Wrong'))
      })
    );
  }
  // ****************************************************************************************** //
  // putMethod() - function takes argument as link and data, passes request to a Node  server  //
  // ******************************************************************************************* //
  putMethodTSH(link:any, data:any)
  {
    return this.http.put(`http://${this.sessionStorage.retrieve('info').hostapi}:${this.sessionStorage.retrieve('info').portapi}/GRAN_INTER/` + link, data)
  }
  
  // ******************************************************************************************* //
  // postMethod() - function takes argument as link and data, passes request to a Node  server  //
  // ****************************************************************************************** //

  getMethodForInterfaceTSH(link:any){
    return this.http.get(`http://${this.sessionStorage.retrieve('info').host}:${this.sessionStorage.retrieve('info').portintf}/GRAN_INTER/` + link,{headers : this.headersInt}).pipe(timeout({each:150000, with : () => throwError(() => new Error('Something Went Wrong'))}));
  }

  postMethodForInterfaceTSH(link:any, data:any){
    return this.http.post(`http://${this.sessionStorage.retrieve('info').host}:${this.sessionStorage.retrieve('info').portintf}/GRAN_INTER/` + link, data ,{ headers : this.headersInt}).pipe(timeout({each:150000, with : () => throwError(() => new Error('Something Went Wrong'))}));
  }

  postMethodClientTSH(link:any, data:any){
    return this.http.post(link,data,{headers: this.headersInt}).pipe(timeout({each:150000, with : () => throwError(() => new Error('Something Went Wrong'))}));
  }
  geIndextMethodForInterfaceTSH(link:any){
    return this.http.get(`http://${this.sessionStorage.retrieve('info').host}:${this.sessionStorage.retrieve('info').portintf}/` + link,{headers : this.headersInt}).pipe(timeout({each:150000, with : () => throwError(() => new Error('Something Went Wrong'))}));
  }
}

